import { api } from "@/api/client";

export type WelderStats = {
  passFailRate: number;
  welderTests: number;
  weldersTested: number;
  weldersAllowedToExpire: number;
  activeWelders: number;
  weldersRevoked: number;
  weldersDisqualified: number;
  testFrequency: number;
};

export type InspectorStats = {
  id: string;
  name: string;
  january: number;
  february: number;
  march: number;
  april: number;
  may: number;
  june: number;
  july: number;
  august: number;
  september: number;
  october: number;
  november: number;
  december: number;
};

export type StandardTestStats = {
  id: string;
  name: string;
  percentage: number;
};

export type DashboardStats = {
  welder: WelderStats;
  inService: WelderStats;
  inspector: InspectorStats[];
  standardTests: StandardTestStats[];
};

export function getDashboardStats() {
  return api.get<DashboardStats>("williams/dashboard/stats");
}
